import React from "react";

import { Stack } from "@mui/material";

import PaginatedTableShell, {
  type PaginatedTableShellProps,
} from "../tables/paginated-table-shell";

type TableViewShellProps = PaginatedTableShellProps;

/**
 * Shared shell for table-based views with visible shadow gutters.
 * Wraps the split header/body table shell.
 */
const TableViewShell: React.FC<TableViewShellProps> = (tableProps) => {
  return (
    <Stack
      sx={{
        flex: 1,
        minHeight: 0,
        py: 1.5,
        px: 1,
        mx: -1,
        overflow: "visible",
      }}
    >
      <PaginatedTableShell {...tableProps} />
    </Stack>
  );
};

export default TableViewShell;